import {
    primaryColor,
  } from "assets/jss/material-kit-pro-react.js";

import {
  hitractTagColor
} from "assets/jss/hitract-styles/hitract-main-styles.js";

const customTextStyle = {
    link: {
      color: '#0798ed',
      cursor: 'pointer'
    }
};

export default customTextStyle;